import { createTheme } from "@mui/material/styles";

export const glymTheme = createTheme({
  palette: {
    primary: { main: "#0AAAAA" },
    secondary: { main: "#143D3A" },
    success: { main: "#4CAF50" },
    warning: { main: "#FF9800" },
    background: { default: "#f5f5f5", paper: "#ffffff" },
    text: { primary: "#1A1A1A", secondary: "#5A5A5A" }
  },
  typography: {
    fontFamily: ["Inter", "Roboto", "Segoe UI", "Arial", "sans-serif"].join(","),
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 }
  },
  components: {
    MuiListItemIcon: { 
      styleOverrides: { 
        root: { minWidth: 36 } 
      } 
    },
    MuiTableCell: {
      styleOverrides: {
        head: { 
          fontWeight: 600, 
          borderBottom: "2px solid #E8E8E8",
          backgroundColor: "#fafafa"
        },
        root: { 
          padding: "10px 16px" 
        }
      }
    },
    MuiAppBar: { 
      styleOverrides: { 
        colorPrimary: { 
          backgroundColor: "#0AAAAA" 
        } 
      } 
    },
    MuiButton: { 
      styleOverrides: { 
        root: { 
          textTransform: "none", 
          borderRadius: 8,
          fontWeight: 500
        },
        contained: {
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.15)"
          }
        }
      } 
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#f9f9f9",
            transition: "background-color 120ms ease"
          }
        }
      }
    }
  }
});

export default glymTheme;
